/**
 * Created by tomere on 03/01/2018.
 */

import {DISTRIBUTION_CONSTANTS} from '../../constants/distribution.constants';
import DistributionSiteModel from '../../core/models/distribution/DistributionSiteModel';
import BundleVersionDAO from '../../modules/distribution/components/bundle/version/DAO/BundleVersionDAO';
import DistributionBundlesDAO from '../../modules/distribution/DAO/bundles/DistributionBundlesDAO';
import SERVICES_CONSTANTS from '../../constants/services.constants';
import DistributionSitesModel from '../../core/models/distribution/DistributionSitesModel';
export default class DistributeService {

    constructor($rootScope, JFrogModal, JFrogEventBus, JFrogNotifications, distributionBundlesDAO, bundleVersionDAO, AppContext) {
        this.$rootScope = $rootScope;
        this.modal = JFrogModal;
        this.jFrogEventBus = JFrogEventBus;
        this.EVENTS = JFrogEventBus.getEventsDefinition();
        this.jfrogNotifications = JFrogNotifications;
        this.distributionBundleResource = distributionBundlesDAO.Resource;
        this.bundleVersionDAO = bundleVersionDAO.Resource;
        this.AppContext = AppContext;
    }

    showSpinner() {
        window.store.dispatch('ENABLE_LOCAL_LOADER');
    }

    hideSpinner() {
        window.store.dispatch('DISABLE_LOCAL_LOADER');
    }

    showVersionDistributionModal(daoParams, preselectedSites, onSuccessCb) {
        this.daoParams = daoParams;
        this.modalScope = this.$rootScope.$new();
        this.modalScope.pairingStatus = this.AppContext.getDistributionPairingStatus();
        this.modalScope.formData = {
            dragDropHeaders: SERVICES_CONSTANTS.distributeBundleService.dragDropHeaders,
            bundle: daoParams.release_bundle,
            version: daoParams.release_bundle_version,
            columns: [{
                header: 'Name',
                field: 'name',
                width: '100%',
                filterable: true,
                cellTemplate: require('../sharedViewTemplate/distribution.site.cell.template.html')
            }],
            availableSites: [],
            selectedSites: [],
            isProcessingRequest: false
        };
        this.modalScope.closeModal = () => {
            return this.modalInstance.close();
        };

        this.modalScope.onSuccess = () => {
            if(this.modalScope && this.modalScope.closeModal) {
                this.modalScope.closeModal();
            }
            if(typeof onSuccessCb === 'function') {
                onSuccessCb();
            }
        };

        this.modalScope.self = this.modalScope;
        this.modalScope.isDistributionDisabled = this.isDistributionDisabled.bind(this);
        this.modalScope.distributeToSelectedSites = this.distributeToSelectedSites.bind(this);
        this.getSites(preselectedSites);
        this.modalInstance = this.modal.launchModalWithTemplateMarkup(require('./distribute.bundle.version.modal.template.html'), this.modalScope, 'lg');
    };

    getSites(preselectedSites) {
        this.showSpinner();
        this.distributionBundleResource.getSites({
            $no_spinner:true,
            action: DISTRIBUTION_CONSTANTS.DISTRIBUTION_ACTIONS.DISTRIBUTE
        }).$promise.then(
        (response) => {
            this.AppContext.setPairingStatus(true);
            this.setAvailableSites(response);
            this.setSelectedSites(preselectedSites);
        }).finally(() => {
            this.hideSpinner();
        });
    }

    setAvailableSites(sites) {
        if (sites.length) {
            sites = _.map(sites, site => new DistributionSiteModel(site));
        }
        Array.prototype.splice.apply(this.modalScope.formData.availableSites, [this.modalScope.formData.availableSites.length, 0].concat(sites));
    }

    setSelectedSites(preselectedSites) {
        // Using a Map for keeping performance in O(n)
        let preSelectedSitesMap = new Map(_.map(preselectedSites, selectedSite => [ selectedSite.name, selectedSite]));
        let removed =_.remove(this.modalScope.formData.availableSites, availableSite => {
            return availableSite.license.valid_license && preSelectedSitesMap.has(availableSite.name);
        });
        Array.prototype.splice.apply(this.modalScope.formData.selectedSites, [this.modalScope.formData.selectedSites.length, 0].concat(removed));
    }

    distributeToSelectedSites() {
        this.distributeToSites(this.modalScope.formData.selectedSites, this.daoParams);
    }

    isDistributionDisabled() {
        return !this.modalScope.formData.selectedSites
            || !this.modalScope.formData.selectedSites.length
            ||  this.modalScope.isProcessingRequest;
    }

    distributeToSites(sites, daoParams) {
        if(!sites || !sites.length || this.modalScope.isProcessingRequest) {
            return;
        }
        this.modalScope.isProcessingRequest = true;
        let payload = new DistributionSitesModel(sites);
        this.bundleVersionDAO.distribute(daoParams, payload.build()).$promise
                .then(() => {
                    this.modalScope.onSuccess();
                    this.jFrogEventBus.dispatch(this.EVENTS.VERSION_DISTRIBUTED);
                });
    }
}

DistributeService.META = {
    name: 'DistributeService'
};

DistributeService.$inject = [
    '$rootScope',
    'JFrogModal',
    'JFrogEventBus',
    'JFrogNotifications',
    DistributionBundlesDAO.META.name,
    BundleVersionDAO.META.name,
    'AppContext'
];



// WEBPACK FOOTER //
// ./modules/distribution/services/distributeBundleVersion/distribute.bundle.version.service.js